import { camelCase } from "text-camel-case";

export const camelizeKeys = <T>(input: T): T => {
  if (input === null || input === undefined) {
    return input;
  }

  if (Array.isArray(input)) {
    return input.map(camelizeKeys) as T;
  }

  if (typeof input === "object" && input.constructor === Object) {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [
        camelCase(key),
        camelizeKeys(value),
      ])
    ) as T;
  }

  return input;
};
